module.exports = __webpack_public_path__ + "img/member_message_icon_ycq.9d1a714e.png";